import { useShallow } from 'zustand/shallow';
import useModalStore from '../zustand/store/useModalStore';

/**
 * @useToastModalOpen toast modal open hook
 <sample>
 -- useToastModalOpen hook import 후 필요한 메세지만 넘기기
    import { useModalOpen } from '../../../hooks/useToastModalOpen';

    const { toastModalOpen } = useModalOpen();
    toastModalOpen('정상적으로 처리 되었습니다.');
 */

export const useModalOpen = () => {

    // toast modal
    const [ setToastState, setText ] = useModalStore(useShallow((state) => [state.setToastState, state.setText]));

    const toastModalOpen = (text) => {
        setText(text);
        setToastState(true);
        const timer = setTimeout(() => {
            setToastState(false);
        }, 2000);
            return () => {
            clearTimeout(timer);
        };
    };

    return {
        toastModalOpen,
    };
};